import { IAppState } from '../../../AppModulesWrapper';

import { selectIsSubagent } from '../user';
import { selectPlacingMoneySource } from '../publishTerms';
import { selectIsInsufficientFunds } from '../checkoutInfo';

import { EMoneySource } from '../../types/reducers/user';

export const selectIsSubagentMasterAccountMoneyLimitExceeded = (state: IAppState): boolean => {
  const isSubagent = selectIsSubagent(state);

  if (!isSubagent) {
    return false;
  }

  const notEnoughMoney = selectIsInsufficientFunds(state);
  const placingMoneySource = selectPlacingMoneySource(state);
  const placingFromMasterAccount = placingMoneySource === EMoneySource.Master;

  return notEnoughMoney && placingFromMasterAccount;
};
